import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30604350"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-14 ant-col-xl-16" }, " Alteração em massa "),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-6 ant-col-xl-8" }, [
    /*#__PURE__*/_createElementVNode("div", { style: {"float":"right"} })
  ])
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Confirmar Alteração", -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = ["title"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = {
  key: 3,
  class: "ss-table-apresentacao-mobile"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "T.DOC:", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "N.Identificação:", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Pessoa:", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Vencimento:", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Valor Título:", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Conta:", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ant-divider ant-divider-horizontal",
  role: "separator",
  style: {"margin-bottom":"10px"}
}, null, -1))
const _hoisted_15 = { class: "ant-row" }
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_18 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_19 = { class: "ant-row" }
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_21 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_card = _resolveComponent("card")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_selecionar_conta = _resolveComponent("selecionar-conta")!
  const _component_selecionar_categoria_plano_conta = _resolveComponent("selecionar-categoria-plano-conta")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    style: {"z-index":"999"},
    width: 1200,
    centered: "",
    "wrap-class-name": _ctx.storeSistema.state.layoutMobile ? 'full-modal ss-modal-financeiro' : 'scroll-modal ss-modal-financeiro',
    maskClosable: false
  }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "ant-btn ant-btn-lg ant-btn-secondary",
        style: {"color":"white","background-color":"dodgerblue"},
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.ConfirmarAlteracao()))
      }, _hoisted_3)
    ]),
    default: _withCtx(() => [
      ((_ctx.modalBase.computedVisivel))
        ? (_openBlock(), _createBlock(_component_a_skeleton, {
            key: 0,
            loading: _ctx.telaBase.carregando,
            paragraph: { rows: 15 }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_card, {
                class: "ss-card-alinhado",
                titulo: "TÍTULOS ADICIONADOS PARA ALTERAÇÃO"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_table, {
                    columns: _ctx.gradeBase.colunas.filter(item => item.visible),
                    "data-source": _ctx.props.titulos,
                    rowKey: "codigoTituloFinanceiro",
                    pagination: false,
                    loading: _ctx.telaBase.carregando,
                    scroll: _ctx.gradeBase.layoutMobile ? null : { x: (_ctx.gradeBase.windowWidth + 150), y: 500 },
                    size: "small"
                  }, {
                    bodyCell: _withCtx(({ column, record, text }) => [
                      (column.key === 'TipoDocumentoFinanceiro')
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            title: record.descricaoTipoDocumentoFinanceiro
                          }, _toDisplayString(record.siglaTipoDocumentoFinanceiro), 9, _hoisted_4))
                        : (column.customRenderRow === _ctx.ECustomRenderRow.MascararData)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(text)), 1))
                          : (column.customRenderRow === _ctx.ECustomRenderRow.MascararFracionado)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text, 2)), 1))
                            : (column.key === 'TituloFinanceiro')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                  _createElementVNode("span", null, [
                                    _hoisted_8,
                                    _createTextVNode(" " + _toDisplayString(record.siglaTipoDocumentoFinanceiro + ' - ' + record.descricaoTipoDocumentoFinanceiro), 1)
                                  ]),
                                  _createElementVNode("span", null, [
                                    _hoisted_9,
                                    _createTextVNode(" " + _toDisplayString(record.numeroTitulo), 1)
                                  ]),
                                  _createElementVNode("span", null, [
                                    _hoisted_10,
                                    _createTextVNode(" " + _toDisplayString(record.nomePessoa), 1)
                                  ]),
                                  _createElementVNode("span", null, [
                                    _hoisted_11,
                                    _createTextVNode(" " + _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(record.dataVencimento)), 1)
                                  ]),
                                  _createElementVNode("span", null, [
                                    _hoisted_12,
                                    _createTextVNode(" R$ " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.saldo, 2)), 1)
                                  ]),
                                  _createElementVNode("span", null, [
                                    _hoisted_13,
                                    _createTextVNode(" " + _toDisplayString(record.descricaoConta), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                    ]),
                    emptyText: _withCtx(() => [
                      (_ctx.props.titulos.length <= 0)
                        ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                            key: 0,
                            mensagem: "Nenhum título adicionado ainda"
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["columns", "data-source", "loading", "scroll"]),
                  _hoisted_14
                ]),
                _: 1
              }),
              _createVNode(_component_card, {
                class: "ss-card-alinhado",
                titulo: "CAMPOS PARA ALTERAÇÃO"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form, { layout: "vertical" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_a_form_item, {
                            label: "Vencimento:",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_data, {
                                dataSelecionada: _ctx.state.dataVencimento,
                                "onUpdate:dataSelecionada": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.dataVencimento) = $event)),
                                onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.alterouVencimento = true))
                              }, null, 8, ["dataSelecionada"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createVNode(_component_a_form_item, {
                            label: "Competência:",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_data, {
                                dataSelecionada: _ctx.state.dataCompetencia,
                                "onUpdate:dataSelecionada": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.dataCompetencia) = $event)),
                                onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.alterouCompetencia = true))
                              }, null, 8, ["dataSelecionada"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(_component_a_form_item, {
                            label: "Valor:",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_campo_numerico, {
                                monetario: true,
                                "quantidade-casas-decimais": 2,
                                valor: _ctx.state.valor,
                                "onUpdate:valor": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.valor) = $event))
                              }, null, 8, ["valor"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _createVNode(_component_selecionar_conta, {
                            codigoSelecionado: _ctx.state.codigoConta,
                            "onUpdate:codigoSelecionado": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.codigoConta) = $event)),
                            empresas: [_ctx.props.empresa]
                          }, null, 8, ["codigoSelecionado", "empresas"])
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _createVNode(_component_a_form_item, {
                            label: "Categoria Plano Conta: ",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_categoria_plano_conta, {
                                codigoSelecionado: _ctx.state.codigoPlanoContaCategoria,
                                "onUpdate:codigoSelecionado": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.codigoPlanoContaCategoria) = $event)),
                                empresas: [_ctx.props.empresa]
                              }, null, 8, ["codigoSelecionado", "empresas"])
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["loading"]))
        : _createCommentVNode("", true),
      _createVNode(_component_requisicao_modal, {
        visivel: _ctx.modalBase.exibirRequisicaoModal,
        "onUpdate:visivel": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
        retornoRequisicao: _ctx.modalBase.retornoRequisicao,
        apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
        fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso
      }, null, 8, ["visivel", "retornoRequisicao", "apresentarBarraProgresso", "fraseBarraProgresso"])
    ]),
    _: 1
  }, 8, ["visible", "wrap-class-name"]))
}